import {
  DOTONE_CELL_ADDRESS,
  DOTONE_CELL_LOGOS,
} from "tools/utils/checkDotoneCellAddress";

import { Image } from "toolkit/chakra/image";
import { Link } from "toolkit/chakra/link";
import React from "react";
import { useColorModeValue } from "toolkit/chakra/color-mode";

const DotoneCellLogo = () => {
  const logo = useColorModeValue(
    DOTONE_CELL_LOGOS.light,
    DOTONE_CELL_LOGOS.dark,
  );

  return (
    <Image
      src={logo}
      alt="Dotone Cell logo"
      boxSize="22px"
      objectFit="contain"
      className="light-shadow-red rounded-full cursor-pointer"
      onClick={() => {
        window.open("https://dotonecell.ir", "_blank", "noopener,noreferrer");
      }}
    />
  );
};

export default DotoneCellLogo;
